import {getColor} from "@/styles/ThemeConfig";
import styled from "@emotion/styled";
import Image from "next/image";
import IC_LEFT_GOLD from "../../../../../public/images/ic_left_gold.svg";
import IC_RIGHT_GOLD from "../../../../../public/images/ic_right_gold.svg";
import Slider from "react-slick";
const StyledSlider = styled(Slider)`
    .slick-list {
        height: auto !important;
        padding-bottom: 50px;
    }
    .slick-track {
        display: flex !important;
        align-items: stretch;
    }
    .slick-slide > div {
        display: flex !important;
        height: 100% !important;
    }

    .slick-track { display: flex; align-items: stretch; }
    .slick-slide { height: auto; }               /* prevent inline height */
    .slick-slide > div { height: 100%; }         /* the extra div Slick inserts */
`;


import {useEffect, useRef, useState} from "react";
import {useRouter} from "next/router";
import VariantBCityTourCard from "@/components/city/cards/VariantBCityTourCard";
import VariantBHistoricalTourCard from "@/components/city/cards/VariantBHistoricalTourCard";
import {breakpoints} from "@/styles/sizes";

const TourSimilarSectionWrapper = styled.div`
    margin: 50px 0;
`


const NavigationLeftWrapper = styled.div`
    z-index: 10;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left:0;
    @media only screen and (${breakpoints.mobile}) {
        display: none;
    }
`;

const NavigationRightWrapper = styled.div`
    z-index: 10;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right:0;

    @media only screen and (${breakpoints.mobile}) {
        display: none;
    }
`;


const NavigationButton = styled.div`
    text-shadow: 1px -1px 6px rgba(0, 0, 0, 0.38);
    color: white;
    font-size: 24px;
    cursor: pointer;
    transform: ${(props) => (props.flip ? 'scaleX(-1)' : 'none')};
`;

const SliderWrapper = styled.div`
    position:relative; 
    padding-left:60px; 
    padding-right:70px;
    
    @media only screen and (${breakpoints.mobile}) {
        padding-left:0;
        padding-right:10px;
    }  
`;

const Title = styled.h2`
    text-transform: uppercase;
    margin-top: 20px;
    margin-bottom: 20px;
    color: ${getColor('gold')};
    font-weight: bold;
    text-align:center;
    font-size:36px;
    // See the note in VariantBWillTasteSection: 24px clipped wrapped titles.
    line-height: 1.2;

    @media only screen and (${breakpoints.mobile}) {
        font-size:25px;
    }
`;


export default function VariantBSimilarToursSection({title, subtitle, tours, historicalTour}) {

    const sliderRef = useRef(null);
    const router = useRouter();
    const [currentIndex, setCurrentIndex] = useState(0);

    const [sliderKey, setSliderKey] = useState(0);

    useEffect(() => {
        const handleRouteChange = () => {
            setCurrentIndex(0);
            setSliderKey(prev => prev + 1); // force slider remount
        };

        router.events.on('routeChangeComplete', handleRouteChange);
        return () => {
            router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, [router.events]);

    const totalSlides = (tours?.length || 0) + (historicalTour ? 1 : 0);

    const settings = {
        initialSlide: currentIndex,
        slidesToShow: 3,         // show up to 3 at a time
        slidesToScroll: 1,
        afterChange: (current) => setCurrentIndex(current),
        arrows: false,
        infinite: totalSlides > 3,
        speed: 500,
        adaptiveHeight: false,
        responsive: [
            { breakpoint: 992, settings: { slidesToShow: 2 } },
            { breakpoint: 640, settings: { slidesToShow: 1 } },
        ],
    };

    return <div className={'container_small'}>
        {
            ((tours && tours?.length > 0) || historicalTour?.title) && <TourSimilarSectionWrapper>
                <div>
                    {title && <Title>
                        {title} {subtitle}
                    </Title>}

                    <SliderWrapper>
                        <NavigationLeftWrapper>
                            <NavigationButton onClick={() => sliderRef.current?.slickPrev()}>
                                <Image src={IC_LEFT_GOLD} alt={'<'} style={{width:'40px', height:'40px', objectFit:'contain'}} />
                            </NavigationButton>
                        </NavigationLeftWrapper>

                        <NavigationRightWrapper>
                            <NavigationButton onClick={() => sliderRef.current?.slickNext()}>
                                <Image src={IC_RIGHT_GOLD} alt={'>'} style={{width:'40px', height:'40px', objectFit:'contain'}} />
                            </NavigationButton>
                        </NavigationRightWrapper>

                        <StyledSlider key={sliderKey} ref={sliderRef} {...settings}>
                            {
                                tours?.map((item, index) => {
                                    return <VariantBCityTourCard key={index} item={item}/>
                                })
                            }

                            {
                                historicalTour &&
                                <VariantBHistoricalTourCard
                                    rating={historicalTour?.rating}
                                    title={historicalTour?.title}
                                    description={historicalTour?.description}
                                    buttonText={historicalTour?.buttonText}
                                    buttonLink={historicalTour?.buttonLink}
                                    image={historicalTour?.image}
                                />
                            }
                        </StyledSlider>
                    </SliderWrapper>
                </div>
            </TourSimilarSectionWrapper>
        }




    </div>

}
